import type { Categoria } from "@/mocks/products";

interface ProductFiltersProps {
  categorias: Categoria[];
  ativo: string;
  onChange: (slug: string) => void;
}

export default function ProductFilters({ categorias, ativo, onChange }: ProductFiltersProps) {
  return (
    <div className="flex flex-wrap gap-2 md:gap-3" role="tablist" aria-label="Filtrar portfólio por categoria">
      {categorias.map((categoria) => {
        const isActive = ativo === categoria.slug;
        return (
          <button
            key={categoria.slug}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(categoria.slug)}
            className={`cursor-pointer whitespace-nowrap rounded-full border px-4 py-2 text-xs transition-all duration-300 md:text-sm ${
              isActive
                ? "border-accent-500 bg-accent-500 text-primary-950"
                : "border-background-300 bg-background-50 text-foreground-600 hover:border-accent-400 hover:text-foreground-900"
            }`}
          >
            {categoria.nome}
          </button>
        );
      })}
    </div>
  );
}